import React from 'react';
import {Link} from 'react-router-dom';
import Avatar from '../../../images/avatar.svg';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Button} from 'reactstrap';

// icons
import IconCancel from 'react-icons/lib/fa/ban';
import FaUser from 'react-icons/lib/fa/user';

// style
import './style.css';
import ReactTooltip from "react-tooltip";
import logo from "../../../images/thoot.png";

const iconObject = {
    IconConfirm: <span className="kr kr-notes"/>,
    IconCancel: <span className="kr kr-cancel"/>,
    IconReject: <span className="kr kr-close"/>,
    IconApprove: <span className="kr kr-approve-schedule"/>,
    IconEdit: <span className="kr kr-edit"/>,
    IconCreate: <span className="kr kr-plus"/>,
    IconImage: <span className="kr kr-image"/>,
    IconCalendar: <span className="kr kr-approve-schedule"/>,
    IconOnHold: <span className="kr kr-on-hold on-hold"/>,
    IconOverdue: <span className="kr kr-history overdue"/>,
};

var flug = true;

const sendNotice = (props) => {
   if (flug) {
       flug = false;
   }  else {
       props.onSeeNotice(props.notices, props.noticesForUsers)
       flug = true
       props.onSeeNotice(props.notices, props.noticesForUsers)
   }
}

const handleRemoveNotice = (props) => {
    props.removeNotice({
        userId: props.currentUser.id,
    });
}

export default (props) => (
    <header className="site-head">
        {(props.role === 'super_admin') ? <div className="left-elems d-flex hidden-lg-up">
            <span className="kr kr-menu" onClick={() => props.toggleNav()}/>
            <span>{}</span>
        </div> : <Link to="/account" className="user-logo">
                    <img src="/static/media/thoot.03adad66.png" alt="Kerenor Booking"/>
        </Link>}

        <div className="right-elems ml-auto d-flex">
            <div className="wrap notify">
                <UncontrolledDropdown className="notification-button">
                    <DropdownToggle className="note-icon" tag="div" onClick={ () => sendNotice(props) }>
                        <span className="kr kr-notification" />
                        {
                            (props.noticeCount > 0 || props.noticesForUsersCount > 0 || props.noticesForUsersCount > 0) ?
                            <span className="badge badge-danger">{props.noticeCount  + (props.noticesForUsersCount ? props.noticesForUsersCount: 0)}</span> : ""
                        }
                    </DropdownToggle>
                    <DropdownMenu right>
                        <div className="notification-area">
                            {
                                props.noticesForUsers && props.noticesForUsers.map(item => (
                                    <Link key={item.id} to={ (props.role === 'super_admin') ? '/sm-admin/dentists' : '/' } className="notification-item">
                                        <DropdownItem className={`${(item.watch) ? 'alreadyWatched' : ''}`}>
                                            <FaUser size="28" className="text-success"/>
                                            <div className="notification-item-txt">
                                                <div>{`User N ${item.id} ${item.first_name} ${item.last_name} has been registered and is waiting for your confirmation.`}</div>
                                            </div>
                                        </DropdownItem>
                                    </Link>
                                ))
                            }
                        {
                            props.notices && props.notices.map((item) => {
                                if(!item.deletedCase) {
                                    return (
                                        <Link key={item.id} to={ (props.role === 'super_admin') ? '/sm-admin/case-details/'+item.caseId : '/case-details/'+item.caseId } className="notification-item">
                                            <DropdownItem className={`d-flex align-items-center ${(item.watch) ? 'alreadyWatched' : ''}`}>
                                                { iconObject[item.icon] }
                                                <p className="notification-item-txt">
                                                    <span>{item.message}</span>
                                                </p>
                                            </DropdownItem>
                                        </Link>
                                    )
                                } else if (item.deletedCase && item.icon === 'IconCancel') {
                                    return <DropdownItem key={item.id} disabled={true} style={{cursor: 'default'}} readOnly={true} className={`d-flex align-items-center ${(item.watch) ? 'alreadyWatched' : ''}`}>
                                                { iconObject[item.icon] }
                                                <p className="notification-item-txt">
                                                    <span>{item.message}</span>
                                                </p>
                                                <ReactTooltip place="right" type="info"/>
                                            </DropdownItem>
                                }
                            })

                        }
                        </div>
                        <div className="notification-footer">
                            {((!props.noticesForUsers || !props.noticesForUsers.length) && (!props.notices || !props.notices.length)) &&
                            <span>You don't have any notifications right now.</span>
                            }

                            {((props.noticesForUsers && props.noticesForUsers.length) > 0 || (props.notices && props.notices.length) > 0) &&
                            <button className="btn btn-link" onClick={() => handleRemoveNotice(props)}>
                                Clear notifications
                            </button>
                            }
                        </div>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>
            <div className="wrap profile">
                <UncontrolledDropdown>
                    <DropdownToggle tag="div">
                        <img src={ Avatar } alt="avatar"/>
                    </DropdownToggle>
                    <DropdownMenu right>
                        {
                            (props.role === 'user') ?
                            (
                                <div className="profile-block">
                                    <span title={props.name} className="profile-block__name">{props.name}</span>
                                    <DropdownItem>
                                        <Link className="profile-block__link" to="/account/profile">
                                            <span className="kr kr-profile"/>
                                            <span className="text">Profile</span>
                                        </Link>
                                    </DropdownItem>
                                </div>
                            ) : (
                                    <div className="pr-item">
                                        <button className="btn btn-link" onClick={() => props.openChangePasswordModal()}>
                                            <span className="kr kr-password"/>
                                            <span className="text">Change Password</span>
                                        </button>
                                    </div>
                                )
                        }
                        <div className="pr-item">
                            <button className="btn btn-link" onClick={props.onLogoutClick}>
                                <span className="kr kr-logout" />
                                <span className="text">Log Out</span>
                            </button>
                        </div>
                    </DropdownMenu>
                </UncontrolledDropdown>
            </div>
        </div>
    </header>
);



// WEBPACK FOOTER //
// ./src/shared/components/header/index.js